import { z } from 'zod';

/** One check in an OpenSSF Scorecard result. */
export const scorecardCheckSchema = z.object({
  name: z.string(),
  /** Score 0-10, or -1 when not applicable. */
  score: z.number(),
  reason: z.string().nullable(),
  documentationUrl: z.string().nullable(),
});
export type ScorecardCheck = z.infer<typeof scorecardCheckSchema>;

/** OpenSSF Scorecard summary for a project. */
export const scorecardSchema = z.object({
  date: z.string().nullable(),
  overallScore: z.number().nullable(),
  checks: z.array(scorecardCheckSchema),
});
export type Scorecard = z.infer<typeof scorecardSchema>;

/**
 * Response for `GET /api/v1/projects/:id` — project health data from deps.dev.
 * The `id` is the project key (e.g. "github.com/facebook/react").
 */
export const projectHealthSchema = z.object({
  id: z.string(),
  description: z.string().nullable(),
  homepage: z.string().nullable(),
  license: z.string().nullable(),
  starsCount: z.number().nullable(),
  forksCount: z.number().nullable(),
  openIssuesCount: z.number().nullable(),
  scorecard: scorecardSchema.nullable(),
});
export type ProjectHealth = z.infer<typeof projectHealthSchema>;
